import React from 'react';
import { Link } from 'react-router';

/**
 * Anchor that routes internally.
 *
 * The ported service pages come from a Next.js build where every link was a
 * plain `<a href>`. Keeping that prop shape means the ported markup did not
 * have to change; this component decides at render time whether the target is
 * an in-app route (react-router `Link`, no full page load) or an external /
 * hash / "#" placeholder target (plain anchor).
 *
 * A bare "#" is intentionally left as an anchor — a few content entries use it
 * to mark a page that does not exist yet.
 */
export function WaqLink({
  href,
  children,
  ...rest
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const internal = href.startsWith('/');

  if (!internal) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}
